import { ChatsWidgets } from '@modules/chat/organisms';
import { useStudentOnlineApplication } from '@modules/students/hooks';
import { StudentOnlineApplication } from '@modules/students/organisms';

const StudentOnlineApplicationPage = () => {
    const { studentOnlineApplication, loading: studentOnlineApplicationLoading } =
        useStudentOnlineApplication();

    const canShowSoa = !studentOnlineApplicationLoading && studentOnlineApplication.isAvailable();

    return (
        <>
            {canShowSoa ? <StudentOnlineApplication /> : null}

            <ChatsWidgets />
        </>
    );
};

export { StudentOnlineApplicationPage };
